import { BaseEntity } from "../BaseEntity";

export interface SectorTypePlantDTO {
  id: string;
  name: string;
  code?: string;
  duns?: string;
  /** From containment-service PlantData.flexnetVersion. */
  flexnetVersion?: string | null;
}

export interface SectorTypeDTO extends BaseEntity {
  type: {
    id: string;
    name: string;
    description?: string;
    createDate?: string;
    updateDate?: string;
    tcn?: number;
  };
  plants?: SectorTypePlantDTO[];
}

export interface SectorDTO {
  id: string;
  name: string;
  description?: string;
  tcn: int;
  createDate?: string;
  updateDate?: string;
  sectorTypes: SectorTypeDTO[];
}

export class Sector implements SectorDTO {
  id = "";
  name = "";
  description?: string;
  tcn: int = 0 as int;
  createDate?: string;
  updateDate?: string;
  sectorTypes: SectorTypeDTO[] = [];

  constructor(dto?: Partial<SectorDTO>) {
    if (dto) Object.assign(this, dto);
  }

}
